var map = {
	"./barstool/features.js": 4786,
	"./foldsOfHonor/features.js": 64711,
	"./golfBook/features.js": 52225,
	"./golfDigest/features.js": 13342,
	"./randomGolf/features.js": 59243,
	"./supremeGolf/features.js": 10473,
	"./theWeatherChannel/features.js": 81256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86514;